import React from 'react'
import PropTypes from 'prop-types'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import LabelInput from '../../../form/component/LabelInput'
import Select from '../../../form/component/Select'

const RoleSelection = ({ roleList, currentRoleId, changeCurrentRoleId }) => {
    return (
        <Row>
            <Column size={6}>
                <LabelInput label="Choose Role">
                    <Select
                        style={{ height: '30px' }}
                        object={{ currentRoleId }}
                        name="currentRoleId"
                        renderer={(role) => {
                            return role.role
                        }}
                        valueList={roleList}
                        addEmpty={true}
                        onChange={changeCurrentRoleId}
                    />
                </LabelInput>
            </Column>
        </Row>
    )
}

RoleSelection.propTypes = {
    roleList: PropTypes.array.isRequired,
    currentRoleId: PropTypes.string,
    changeCurrentRoleId: PropTypes.func.isRequired,
}

export default RoleSelection



// WEBPACK FOOTER //
// ./src/modules/security/component/manage/RoleSelection.js